import { CnRangeDatePickerPro as UiCnRangeDatePickerPro } from '@/components/cn-date-picker-pro';
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnRangeDatePickerPro = connect(UiCnRangeDatePickerPro, mapProps(mapSize, mapStatus));
